module.exports = __webpack_public_path__ + "img/US.2e4030bc.svg";